<template>
    <v-navigation-drawer permanent app v-if="isLoggedIn">
        <v-list-item>
            <v-list-item-content>
                <v-list-item-title class="text-h6">
                    映智科技後台管理
                </v-list-item-title>
                <v-list-item-subtitle>
                    <div v-if="currentUser.data.target">
                        {{ currentUser.data.target.name }}
                    </div>
                    <div>{{ currentUser.account }}</div>
                </v-list-item-subtitle>
            </v-list-item-content>
        </v-list-item>
        <v-divider></v-divider>
        <v-list nav>
            <v-list-item-group>
                <v-list-group
                    color="primary"
                    v-for="group in groups"
                    :key="group"
                    :prepend-icon="icon(group)"
                >
                    <template v-slot:activator>
                        <v-list-item-content>
                            <v-list-item-title>{{ group }}</v-list-item-title>
                        </v-list-item-content>
                    </template>
                    <v-list-item
                        class="ml-8"
                        v-for="item in items[group]"
                        :key="item.meta.title"
                        @click="navigateTo(item)"
                    >
                        <v-list-item-icon>
                            <v-icon dense v-text="item.meta.icon"></v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                            <v-list-item-title>{{
                                item.meta.title
                            }}</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                    <v-spacer />
                </v-list-group>
                <v-list-item
                    color="primary"
                    v-for="item in items['undefined']"
                    :key="item.title"
                    link
                    @click="navigateTo(item)"
                >
                    <v-list-item-icon>
                        <v-icon dense v-text="item.meta.icon"></v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                        <v-list-item-title>{{
                            item.meta.title
                        }}</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
            </v-list-item-group>
            <v-list-item @click="clickLogout">
                <v-list-item-icon>
                    <v-icon dense v-text="'mdi-logout'"></v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                    <v-list-item-title>登出</v-list-item-title>
                </v-list-item-content>
            </v-list-item>
        </v-list>
    </v-navigation-drawer>
</template>

<script>
import _ from 'lodash';
import VueRouter from 'vue-router';
import { mapGetters, mapActions } from 'vuex';

const { isNavigationFailure, NavigationFailureType } = VueRouter;

export default {
    data: () => ({
        snackbar: false,
    }),
    computed: {
        ...mapGetters('auth', ['isLoggedIn', 'currentUser']),
        routes() {
            const routes = this.$router ? this.$router.getRoutes() : [];
            return _.chain(routes).filter('meta.title').value();
        },
        groups() {
            return _.chain(this.routes)
                .flatMap((route) => route.meta.group)
                .uniq()
                .filter()
                .filter((group) => !_.isEmpty(this.items[group]))
                .value();
        },
        items() {
            return _.chain(this.routes)
                .filter((route) => {
                    const role = route.meta?.role;
                    return role == null || role === this.currentUser?.role;
                })
                .groupBy((route) => route.meta?.group)
                .value();
        },
        icon() {
            return (group) => _.get({
                媒體訊息: 'mdi-format-list-bulleted',
                投資關係: 'mdi-chart-box',
                人員管理: 'mdi-account',
            }, group);
        },
    },
    methods: {
        ...mapActions('auth', ['logout']),
        navigateTo(item) {
            this.$router.replace(item).catch((failure) => {
                if (isNavigationFailure(failure, NavigationFailureType.redirected)) {
                    this.$showError('請先登入');
                } else if (!isNavigationFailure(failure, NavigationFailureType.duplicated)) {
                    throw failure;
                }
            });
        },
        clickLogout() {
            this.logout();
            this.$router.replace({ name: 'Login' });
        },
    },
    mounted() {
        // this.$router.afterEach((to) => {
        //     const activeItem = _.chain(this.items).map((pages, group) => {
        //         const index = _.findIndex(pages, (item) => {
        //             const isSubPage = item.name === to.meta.tab;
        //             return item.name === to.name || isSubPage;
        //         });
        //         return { group, pages: pages.length, found: index };
        //     }).reduce((pre, current) => {
        //         if (pre.group) return pre;
        //         if (current.found >= 0) {
        //             return { group: current.group, i: pre.i + current.found };
        //         }
        //         return { group: null, i: pre.i + current.pages };
        //     }, { group: null, i: this.groups.length + 1 }).value();
        // });
    },
};
</script>

<style>
</style>
